class AppConst {
  static APP_NAME = "マイ家紋";
  static APP_HASHTAG_EN = "my_kamon";
}

export default AppConst;
